import { ProductData } from '~/types/product';

type UseFamilyProductDataLabelsType = {
    familyProductTypeShortLabel: ComputedRef<null | string>;
    familyProductTypeShortLabelPlural: ComputedRef<null | string>;
    familyQuantityDescription: ComputedRef<null | string>;
    familyQuantityDescriptionPlural: ComputedRef<null | string>;
    familyTurnaroundTime: ComputedRef<null | string>;
};

function useFamilyProductDataLabels(
    productDatas: Ref<ProductData[]>,
    quantity: Ref<number> = ref(1),
): UseFamilyProductDataLabelsType {
    const totalQuantity = computed(() => {
        return productDatas.value.length
            ? productDatas.value[0].uomCount * quantity.value
            : 1;
    });

    const familyProductTypeShortLabel = computed(() => {
        if (!productDatas.value.length) {
            return null;
        }

        return productDatas.value[0].productTypeShortLabel;
    });

    const familyProductTypeShortLabelPlural = computed(() => {
        if (!productDatas.value.length) {
            return null;
        }

        return productDatas.value[0].productTypeShortLabelPlural;
    });

    const familyQuantityDescription = computed(() => {
        if (!productDatas.value.length) {
            return null;
        }

        const productData = productDatas.value[0];

        if (
            !productData.uomType ||
            !productData.uomCount ||
            !productData.productTypeShortLabelPlural
        ) {
            return null;
        }

        return `${productData.uomType} of ${productData.uomCount} ${productData.productTypeShortLabelPlural}, (${totalQuantity.value} total)`;
    });

    const familyQuantityDescriptionPlural = computed(() => {
        if (!productDatas.value.length) {
            return null;
        }

        const productData = productDatas.value[0];

        if (
            !productData.uomTypePlural ||
            !productData.uomCount ||
            !productData.productTypeShortLabelPlural
        ) {
            return null;
        }

        return `${productData.uomTypePlural} of ${productData.uomCount} ${productData.productTypeShortLabelPlural}, (${totalQuantity.value} total)`;
    });

    const familyTurnaroundTime = computed(() => {
        if (!productDatas.value || !productDatas.value.length) {
            return null;
        }

        return productDatas.value[0].turnaroundTime;
    });

    return {
        familyProductTypeShortLabel,
        familyProductTypeShortLabelPlural,
        familyQuantityDescription,
        familyQuantityDescriptionPlural,
        familyTurnaroundTime,
    };
}

export default useFamilyProductDataLabels;
